// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import AbTestSvg from '@rsuite/icon-font/lib/application/AbTest';
var AbTest = createSvgIcon({
  as: AbTestSvg,
  ariaLabel: 'ab test',
  category: 'application',
  displayName: 'AbTest'
});
export default AbTest;